import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import horseUrlBuilder from './urlBuilder';

const ColumnSireLine = ({ data, rowData }) => (
    data === '—' ? <span>—</span> : (
        <a
            href={horseUrlBuilder(rowData.sire_line_uid,
                                  rowData.sire_line_style_name)}
            className="js-popupLink ui-link ui-link_table"
        >
            {data}
            <Svg
                iconName="right"
                size="XSmall"
            />
        </a>
    )
);

ColumnSireLine.propTypes = {
    rowData: PropTypes.object,
    data: PropTypes.string
};

export default ColumnSireLine;



// WEBPACK FOOTER //
// ./src/client/components/GriddleRP/ColumnSireLine.js